// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__toZzR","list":"Tabs_list__tSLfU","tab":"Tabs_tab__yy2OC","label":"Tabs_label__0BT9t","indicator":"Tabs_indicator__IvQUP","pill":"Tabs_pill__xvAzM"};